import { FileUpload } from '../../../../common/FileUpload';

interface NoteFileUploadProps {
  selectedFiles: File[];
  onFileSelect: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveFile: (index: number) => void;
  uploadingFiles: boolean;
}

export const NoteFileUpload: React.FC<NoteFileUploadProps> = (props) => {
  return (
    <FileUpload
      {...props}
      inputId="note-attachment-upload"
    />
  );
};
